import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'trait';

export const { focus } = createLifecycleFor(TYPE);
